<template>
  <div>
    <a-skeleton :loading="isloading" active>
      <div>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            订单编号
            <span class="font-color">{{ info.id }}</span>
          </a-col>
          <a-col :span="12">
            订单状态
            <span class="font-color" v-if="info.orderStatus == 1">待支付</span>
            <span class="font-color" v-else-if="info.orderStatus == 2">待发货</span>
            <span class="font-color" v-else-if="info.orderStatus == 3">待收货</span>
            <span class="font-color" v-else-if="info.orderStatus == 4">待评价</span>
            <span class="font-color" v-else-if="info.orderStatus == 5">已评价</span>
            <span class="font-color" v-else-if="info.orderStatus == 6">已取消</span>
            <span class="font-color" v-else>已退款</span>

          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            订单金额
            <span class="font-color">
              ￥{{ info.totalprice }}
            </span>
          </a-col>
          <a-col :span="12">
            支付金额
            <span class="font-color">￥{{ info.payprice }}</span>
          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">

          <a-col :span="12">
            商品总价格
            <span class="font-color">￥{{ info.productprice }}</span>
          </a-col>
        </a-row>
        <a-divider orientation="left">订单信息</a-divider>

        <a-row class="orderInfo_marB">
          <a-col :span="12">
            买家信息
            <span class="font-color">{{ info.telephone }} {{ info.userName }}</span>
          </a-col>
          <a-col :span="12">
            支付方式
            <span class="font-color">
              <a-tag v-if="info.paymentMethod == 'wechatapp'" color="#01D10C">微信APP</a-tag>
              <a-tag v-else-if="info.paymentMethod == 'wechatqr'" color="#01D10C">微信扫码</a-tag>
              <a-tag v-else-if="info.paymentMethod == 'alipayapp'" color="#079DEA">支付宝APP</a-tag>
              <a-tag v-else-if="info.paymentMethod == 'alipayqr'" color="#079DEA">支付宝扫码</a-tag>
              <a-tag v-else-if="info.paymentMethod == '线下支付'" color="#079DEA">线下支付</a-tag>
            </span>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            下单时间
            <span class="font-color">{{ info.addtime }}</span>
          </a-col>
          <a-col :span="12"></a-col>
        </a-row>
      </div>
    </a-skeleton>
    <!-- <a-divider /> -->
    <!-- <p>商品信息</p> -->
    <a-divider orientation="left">商品信息</a-divider>

    <a-table :columns="list.columns" rowKey="id" :pagination="false" :dataSource="list.datas" :loading="isloading"
      :locale="{ emptyText: '暂无数据' }">
      <span slot="headUrl" slot-scope="headUrl">
        <a-avatar :src="headUrl" />
      </span>
      <span slot="is_deleted" slot-scope="is_deleted,recode">
        <a-tag v-if="recode.is_refund == 1" color="red">已退款</a-tag>
        <a-tag v-else-if="recode.is_refund == 0 && is_deleted == 1" color="red">已移除 </a-tag>
        <a-tag v-else color="green">正常</a-tag>
      </span>
      <span slot="action" slot-scope="action">
        {{ action.buyPrice * action.count }}
      </span>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    dataIndex: "productName",
    key: "productName",
    align: "center",
    title: "商品名称"
  },
  {
    dataIndex: "buyPrice",
    key: "buyPrice",
    align: "center",
    title: "价格"
  },
  {
    dataIndex: "count",
    key: "count",
    align: "center",
    title: "数量"
  },
  {
    dataIndex: "is_deleted",
    key: "is_deleted",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "is_deleted" }
  },
  {
    key: "total",
    align: "center",
    title: "小计",
    scopedSlots: { customRender: "action" }
  }
];


var that;

export default {
  props: {
    infos: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 999999 //页容
        }
      },
      info: {
        postage: 123,
      },
      isloading: false,
      loadingTip: "加载中..."
    };
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      // console.log("asdasd", this.cInfo);
      this.orderInfo();
    });
  },
  methods: {
    closeLoading() {
      this.isloading = false;
    },
    orderInfo() {
      this.isloading = true;
      this.$api.order
        .ogetById(this.infos.id)
        .then(res => {
          //console.log("角色信息", res);
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data.order;
            this.list.datas = res.data.order.orderitemList;

          } else {
            this.error(res.errorMsg);
            //this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.font-color {
  color: #999;
  margin-left: 10px;
}

.orderInfo_marB {
  margin-bottom: 15px;
  line-height: 32px;
}

.orderInfo_marB input,
.ant-input-group-wrapper {
  width: 60%;
}

.icon_rg {
  margin-left: 10px;
}
</style>